import { SectionsPage } from "@/components/SectionsPage";

export default function CaseStudies() {
  return (
    <SectionsPage
      seoTitle="Cybersecurity Case Studies & Results | Aliwer"
      seoDescription="Real-world cybersecurity outcomes delivered by Aliwer — assessments, engineering, and managed security results."
      path="/case-studies"
      eyebrow="Case Studies"
      title="Results, in the real world."
      subtitle="Selected outcomes from our assessments, engineering, and managed security engagements."
      sections={[
        { heading: "Case study — coming soon", body: "A summary of the client challenge, our approach, and measurable results will appear here as engagements are published with client approval." },
        { heading: "Case study — coming soon", body: "A second engagement, with outcomes and metrics, will appear here." },
      ]}
      note="Published, client-approved case studies will appear here as engagements complete."
      cta={{ label: "Become our next success story", to: "/contact" }}
      testid="case-studies"
    />
  );
}
